import { useEffect } from 'react';
import { defaultUserData } from '../../shared/constants/userDefault';
import { parsePathname, redirect, useLocation } from '../features/routing';
import { ROUTES, SECTIONS } from '../features/routing/constants';
import { MoodRecordDraftProvider } from '../lib/moodUtils/MoodRecordDraftContext';
import { useUserData } from '../lib/userData/UserDataProvider';
import { WelcomePage } from '../pages/WelcomePage';
import { HomePage } from '../pages/home/HomePage';
import { LoginPage } from '../pages/login/LoginPage';
import { MoodLogEntryPage } from '../pages/moodLogEntry/MoodLogEntryPage';
import { PatchesPage } from '../pages/patches/PatchesPage';
import { ProfilePage } from '../pages/profile/ProfilePage';

// const renderCount = 0;

export const Routes = () => {
  const location = useLocation();
  const { section } = parsePathname(location);

  // useEffect(() => {
  //   console.log(`%clocation is now:`, 'background:cyan; color:black;', location);
  // }, [location]);

  const [userData, isLoading] = useUserData();
  const isLoggedIn = userData.email !== '' && userData.email !== defaultUserData.email;
  const ownerUid = userData.firebaseUserId;

  useEffect(() => {
    // console.log(
    //   `%cisLoggedIn ${!renderCount++ ? 'Started as' : 'Changed to'}:`,
    //   'background:cyan; color:black;',
    //   isLoggedIn
    // );
  }, [isLoggedIn, isLoading]);

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (location === ROUTES.Welcome) {
    return <WelcomePage />;
  }
  if (isLoggedIn) {
    switch (section) {
      case SECTIONS.Home:
        return <HomePage />;
      case SECTIONS.Mood_log_entry:
        return (
          <MoodRecordDraftProvider ownerUid={ownerUid}>
            <MoodLogEntryPage />
          </MoodRecordDraftProvider>
        );
      case SECTIONS.Patches:
        return <PatchesPage />;
      case SECTIONS.Profile:
        return <ProfilePage />;
    }
    redirect(userData.startingPage);
  } else {
    if (section === SECTIONS.Login) {
      return <LoginPage />;
    } else {
      redirect(ROUTES.Login);
    }
  }
  return null;
};
